import { render, staticRenderFns } from "./ExpensesFilters.vue?vue&type=template&id=2220fde9"
import script from "./ExpensesFilters.vue?vue&type=script&lang=js"
export * from "./ExpensesFilters.vue?vue&type=script&lang=js"
import style0 from "./ExpensesFilters.vue?vue&type=style&index=0&id=2220fde9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports